import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ActionButton.css';

/**
 * Circular icon button for table Actions columns. Stops click from selecting/opening the row.
 */
const ActionButton = ({ icon, onClick, disabled, title }) => (
  <button
    type="button"
    onClick={(event) => {
      event.stopPropagation();
      if (!disabled && onClick) {
        onClick(event);
      }
    }}
    disabled={disabled}
    className={`table-action-button${disabled ? ' disabled-button' : ''}`}
    title={title}
  >
    <FontAwesomeIcon icon={icon} />
  </button>
);

export default ActionButton;
